module.exports = __webpack_public_path__ + "static/img/mobilebanner2.97e9953.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/front/mobilebanner2.png
// module id = orGM
// module chunks = 1